// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4242":"bc9a6aaf","5019":"e43a18b1","6779":"681a9524"}[chunkId] + ".chunk.css";
};